import AccessEditor from '@app/components/AccessEditor'
import CheckBox from '@app/components/CheckBox'
import CompanySelector from '@app/components/CompanySelector'
import EditPageContainer from '@app/components/EditPageContainer'
import MembershipEditor from '@app/components/MembershipEditor'
import { IEntityAllow } from '@app/models/EntityAllow'
import { MembershipType } from '@app/models/enums'
import { ICurrentUserState } from '@app/store/modules/account'
import { bindFunctions } from '@app/utils/class'
import { humanize } from '@app/utils/formatting'
import { List } from 'immutable'
import * as React from 'react'
import { RouteComponentProps } from 'react-router-dom'
import { Input } from 'reactstrap'
import { actionCreators, IUserEditState } from '../modules/userEdit'

interface IComponentRouterProps {
  id: string
}

type IComponentProps = IUserEditState &
  ICurrentUserState &
  RouteComponentProps<IComponentRouterProps> &
  typeof actionCreators

export default class UserAddPage extends React.PureComponent<IComponentProps> {
  public userId: string

  constructor(props: IComponentProps) {
    super(props)

    bindFunctions(this)
  }

  public componentDidMount() {
    const { id } = this.props.match.params

    this.userId = id

    this.props.loadUser(id)
  }

  public componentWillUnmount() {
    this.props.resetState()
  }

  public render() {
    return (
      <EditPageContainer
        saveDisabled={
          this.props.user &&
          this.props.user.user &&
          this.props.user.user.password !== this.props.user.user.confirmPassword
            ? true
            : false
        }
        title='New User'
        onSaveClick={this._saveUser}
        onCancelClick={this._cancel}
      >
        <div className='container my-2'>{this._renderBasicInfo()}</div>
      </EditPageContainer>
    )
  }

  private _saveUser() {
    this.props.save(this.userId)
  }

  private _cancel() {
    this.props.history.goBack()
  }

  private _renderBasicInfo() {
    if (!this.props.user || !this.props.user.user) {
      return null
    }

    return (
      <div>
        <div className={`d-flex flex-row`}>
          <div className='mr-2 flex-grow-1'>
            <Input
              placeholder='First'
              value={this.props.user ? this.props.user.firstName : ''}
              className='mb-2'
              name='FirstName'
              required
              onChange={(e) => this.props.setFirstName(e.target.value)}
            />

            <Input
              type='password'
              placeholder='Password'
              className='mb-2'
              onChange={(e) => this.props.setPassword(e.target.value)}
              value={this.props.user.user.password}
              required
            />

            <Input
              type='email'
              placeholder='Email'
              onChange={(e) => this.props.setEmail(e.target.value)}
              value={this.props.user.user.username}
              required
            />
          </div>
          <div className='flex-grow-1'>
            <Input
              placeholder='Last'
              className='mb-2'
              value={this.props.user ? this.props.user.lastName : ''}
              name='LastName'
              required
              onChange={(e) => this.props.setLastName(e.target.value)}
            />

            <Input
              type='password'
              placeholder='Confirm Password'
              onChange={(e) => this.props.setConfirmPassword(e.target.value)}
              value={this.props.user.user.confirmPassword}
              required
            />
          </div>
        </div>
        <div
          className={`${
            this.props.user.user.password !==
            this.props.user.user.confirmPassword
              ? 'd-inline'
              : 'd-none'
          }`}
        >
          <strong className='text-danger'>
            Password and verify password do not match
          </strong>
        </div>
      </div>
    )
  }

  private _renderRoles() {
    return (
      <MembershipEditor
        value={this.props.user.user}
        type={MembershipType.Role}
        onChange={this.props.changeMembership}
      />
    )
  }

  private _renderTeams() {
    return (
      <MembershipEditor
        value={this.props.user.user}
        type={MembershipType.Team}
        onChange={this.props.changeMembership}
      />
    )
  }

  private _renderSpecialPermissions() {
    if (!this.props.user.user) {
      return null
    }

    const user = this.props.user.user

    const permissions = Object.keys(user.permissions.specialPermissions).map(
      (item: any) => {
        return (
          <div key={item} className='d-flex flex-row'>
            <CheckBox
              value={user.permissions.specialPermissions[item]}
              className='mr-2'
              onChange={(e) => this.props.setPermission(e, item)}
            />
            {humanize(item)}
          </div>
        )
      },
    )

    return <div className='ml-2'>{permissions}</div>
  }
}
